import { Logo, HeartLogo } from './styled';

function Header() {
  return (
    <header style={{ gridArea: 'header' }}>
      <a href='https://contribute.to'>
        <Logo />
        <HeartLogo />
      </a>
    </header>
  );
}

export { Header };
